import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsSocialMediaSettingsEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsSocialMediaSettingsEntity
